import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { StarProvider } from './components/StarContext';

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <StarProvider>
      <App />
    </StarProvider>
  </BrowserRouter>
);


